import React, { useState, useEffect, useRef } from 'react';
//import { RestApiUtils } from '../utils/RestApiUtils'
import { LiveService } from '../services/live-service';
//import Debug from '../components/debug';
import HintError from '../components/hint-error';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useFormik } from 'formik';

export default function AddLivetag({ onUpdate }) {

    const innerRef = useRef();

    const [errors, setErrors] = useState([]);

    //Formik
    const formik = useFormik({
        initialValues: { name: '', slug: '', description: '' },
        enableReinitialize: true,
        onSubmit: values => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    useEffect(() => { innerRef.current.focus() }, []);

    async function save() {

        //let imsg = null;
        let data = formik.values;

        try {
            let resObject = await LiveService.addTag(data);
            let res = {
                livet: resObject.data,
                error_code: resObject.status,
                error_msg: resObject.data
            };

            if (!res || res.error_code !== 201) {
                console.log(`Error setLiveview: `, res.error_msg);
                //imsg = JSON.stringify(res.error_msg);
                setErrors(res.error_msg);
                onUpdate(null, false);
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }

            console.log(`Result of PUT:`, res.livet);
            onUpdate(res.livet, true)
            setErrors([]);

        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }

    return (
        <>
            <div className="card mybox w-100">
                <div className="card-body">
                    <div className="card-title">
                        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="col-12">
                                <span className="fw-bold">
                                    <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                    &nbsp;Name: <HintError errors={errors?.name} ></HintError></span>

                                <input type="text" id="name" className="form-control" ref={innerRef}
                                    style={{ width: "100%", border: errors?.name ? "2px solid red" : '' }}
                                    onChange={formik.handleChange}
                                    value={formik.values.name}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="card-title">
                        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="col-12">
                                <span className="fw-bold">
                                    <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                    &nbsp;Slug: <HintError errors={errors?.slug} ></HintError></span>

                                <input type="text" id="slug" className="form-control" style={{ width: "100%", border: errors?.slug ? "2px solid red" : '' }}
                                    onChange={formik.handleChange}
                                    value={formik.values.slug}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="card-title">
                        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="col-12">
                                <span className="fw-bold">Description:</span>
                                <input type="text" id="description" className="form-control" style={{ width: "100%" }}
                                    onChange={formik.handleChange}
                                    value={formik.values.description}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ margin: "12px" }}>
                    <div className="d-grid gap-2 d-md-block">
                        <div className="row">
                            <div className="col-12">
                                <button type="button" onClick={() => { save(); }} className="btn btn-primary" style={{ width: "6rem", float: "right" }}>Salva</button>
                                <span style={{ color: "red", float: "right", margin: "16px 10px 0px 0px" }}>
                                    <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                    <span className="user-select-none">Indica un campo obbligatorio</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Debug obj={liveviewCard} name={"lvCard"}></Debug>
                    <Debug obj={formik.values} name={"formik.values"}></Debug> */}
        </>
    );
}